import React, { useEffect, useState } from "react";

import EmptyState from "shared/components/data-display/tables/EmptyState";
import Loading from "shared/components/feedback/loading/Loading";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import { useLocation } from "react-router-dom";
import usePermissionsByEmployeeApi from "./usePermissionsByEmployeeApi";
import { Container } from "./AccessGroup.styles";

const arrow = " > ";

const AccessGroupList = ({ userId, departmentId, onClose }) => {
    const [permissions, setPermissions] = useState(null);
    const [loading, setLoading] = useState(false);
    const { getAccessesByEmployee } = usePermissionsByEmployeeApi();
    const location = useLocation();

    const CTAProps = {
        leadingIcon: "filter",
        label: "Manage Access Groups",
        onClick: onClose,
    };

    const pageItemOnClick = (pageId) => {
        let div = document.getElementById(`permissions_${pageId}`);
        if (div) {
            div.style.display = div.style.display === "block" ? "none" : "block";
        }
    }

    useEffect(() => {
        const fetchPermissions = async () => {
            setLoading(true);
            try {
                const result = await getAccessesByEmployee(userId, departmentId);
                setPermissions(result);
            } catch (error) {
                console.error("Error fetching permissions:", error);
                setPermissions(null);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [userId, departmentId, getAccessesByEmployee]);

    if (location.pathname !== "/admin/accessgroups") {
        return <></>;
    }

    const renderContent = () => {
        if (loading) {
            return <Loading />;
        }

        if (permissions?.pages?.length === 0) {
            return (
                <EmptyState
                    message="This Employee has not any page access"
                    actionPropsForTernaryButton={CTAProps}
                />
            );
        }

        return (
            <>
                {permissions?.pages?.map((page) => (
                    <React.Fragment key={page.id}>

                        <button
                            type="button"
                            style={{
                                color: 'black',
                                cursor: 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                font: 'inherit',
                                textAlign: 'left'
                            }}
                            title={page.tooltip}
                            onClick={() => pageItemOnClick(page.id)}>
                            <b>{page.name}</b>{arrow}
                        </button>

                        <div style={{ display: "none" }} id={"permissions_" + page.id}>

                            {
                                page.permissions && page.permissions.length > 0 &&
                                <u>Permissions allowed in page</u>
                            }
                            
                            {page.permissions.map((permpage) => (
                                <div key={permpage.name}>
                                    {permpage.name}
                                </div>
                            ))}

                            <div></div>

                            <u>Granted by</u>
                            {
                                page.grantedBy.map((g) => (
                                    <div key={g.name}>{g.name}</div>
                                ))
                            }
                        </div>
                    </React.Fragment>
                ))}
            </>
        );
    };

    return (
        <Container>
            <Text variant="Descriptive_1_1" color="Gray_2">
                Page Accesses
            </Text>
            {renderContent()}
        </Container>
    );
};

AccessGroupList.propTypes = {
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    departmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func,
};

export default AccessGroupList;
